// システム列の定義

import { ColumnId, createColumnId, ColumnName, createColumnName } from './id.types';

// RowNumber列のID（予約列ID）
export const ROW_ID_COLUMN_ID = createColumnId('__system_rowid__');

// RowNumber列の表示名
export const ROW_ID_COLUMN_NAME: ColumnName = createColumnName('Row #');

// システム列かどうかを判定
export function isSystemColumn(columnId: ColumnId): boolean {
  return columnId === ROW_ID_COLUMN_ID;
}